<template>
  <div class="news_component">
    <div class="article">
        <button :class="'btn' + this.active1" @click="sentfilter('')" :value="''" style="font-family: 'Noto Sans TC', sans-serif;">全部消息</button>
        <button :class="'btn' + this.active2" @click="sentfilter('企業活動')" :value="'企業活動'" style="border-left:0;border-right:0;font-family: 'Noto Sans TC', sans-serif;">企業活動</button>
        <button :class="'btn' + this.active3" @click="sentfilter('金石盃賽')" :value="'金石盃賽'" style="font-family: 'Noto Sans TC', sans-serif;">金石盃賽</button>
      <div class="newslist">
        <span v-for="(news, index) in filternews" :key="news.id" v-show=" ((pagenumber-1)*3 <= index)&& (index < (pagenumber)*3)">
          <p id="newslistanimation"><span id="newsdate">{{news.date}}</span><span id="newstitle">{{news.title}}</span><span id="newscontent"><a :href="news.href" target="_blank">{{news.content}}</a></span></p>
          <hr id="newshr">
        </span>
        <span id="pageoffset"><hr id="pagehrleft">
        <span v-for="i in pageoffsetnumber" :key="i" :value="i" @click="pagesetting(i)"
             :class="{ pagepactive : pagenumber == i , pagep :  i }">{{i}}</span>
        <hr id="pagehrright"></span>
      </div>

    </div>
    <router-link class='seemore-group' id="seemore-news" to="/news">看更多</router-link> 
  </div>
  
</template>
 
<script>
export default {
  data(){
    return {     
      filtername:'', active1:' active',active2:'',active3:'', //button
      newslist:[],filterchoice:"",  //最新消息
      pagenumber:1, //頁數
      limiter: 0, 
      }
  },
  created(){
      this.getnewslist()
    },
  methods:{
    sentfilter(a){
      this.filtername = a
      this.pagenumber = 1
      if(this.filtername === '企業活動'){
        this.filterchoice = '企業活動'
        this.active1 = ''
        this.active2 = ' active'
        this.active3 = ''
      }      
      else if(this.filtername === '金石盃賽'){
        this.filterchoice = '金石盃賽'
        this.active1 = ''
        this.active2 = ''
        this.active3 = ' active'
      }else{
        this.filterchoice = ''
        this.active1 = ' active'
        this.active2 = ''
        this.active3 = ''      
      }
      //console.log(this.filtername)
    },
    getnewslist(){
      this.newslist = [
          { id: 21, thefiltername: '企業活動', date: '2021.09.03', title: '新聞媒體', content: '金石成大砌️‼十年磨一案 嘉義最大場‼️',href:"https://www.facebook.com/kingstonecy1986/posts/4612047312163368"},
          { id: 20, thefiltername: '企業活動', date: '2021.07.26', title: '新聞媒體', content: '💥狂賀💥金石建設贊助選手林昀儒勇奪東奧銅牌🥉',href:"https://www.facebook.com/kingstonecy1986/videos/317499186770127/"},
          { id: 19, thefiltername: '企業活動', date: '2021.06.23', title: '新聞媒體', content: '【 房貸紓困 💰 金石幫您 】',href:"https://www.facebook.com/kingstonecy1986/posts/4399072870127481"},

          { id: 17, thefiltername: '金石盃賽', date: '2021.04.20', title: '金石盃賽', content: '金石桌球員工盃暖身賽圓滿落幕🎊',href:"https://www.facebook.com/kingstonecy1986/posts/4209401569094613"},
          { id: 16, thefiltername: '企業活動', date: '2021.04.17', title: '新聞媒體', content: '恭喜🎊🎊🎊金石建設柯建利總經理榮獲✨嘉中第11屆傑出校友✨',href:"https://www.facebook.com/kingstonecy1986/posts/4199109776790459"},
          { id: 14, thefiltername: '企業活動', date: '2021.03.07', title: '新聞媒體', content: '恭喜🎊台灣ㄧ哥林昀儒卡達桌賽獲獎',href:"https://www.facebook.com/kingstonecy1986/posts/4077842055583899"},
          { id: 13, thefiltername: '企業活動', date: '2021.02.24', title: '新聞媒體', content: '金石建設千人尾牙趴',href:"https://www.facebook.com/kingstonecy1986/videos/888501021897014/"},
          { id: 12, thefiltername: '企業活動', date: '2021.01.05', title: '新聞媒體', content: '金石鉑克萊 嘉義東區首選',href:"https://www.facebook.com/kingstonecy1986/posts/2978515155516600"},
          { id: 11, thefiltername: '企業活動', date: '2020.01.29', title: '新聞媒體', content: '台灣大未來 大年初一特別節目 金石建設',href:"https://www.facebook.com/kingstonecy1986/posts/2978515155516600"},
          { id: 1, thefiltername: '企業活動', date: '2020.01.09', title: '運動比賽', content: '金石乒乓球館成立 歡迎愛好桌球的朋友來運動',href:"https://www.facebook.com/%E9%87%91%E7%9F%B3%E4%B9%92%E4%B9%93%E7%90%83%E9%A4%A8-110772700450808/"},
          { id: 2, thefiltername: '企業活動', date: '2019.11.26', title: '新聞媒體', content: '✸✸狂賀✸✸恭喜金石建設獲國家建築金質獎🎉',href:"https://www.facebook.com/kingstonecy1986/posts/2833201443381306"},
          { id: 3, thefiltername: '企業活動', date: '2019.11.25', title: '新聞媒體', content: '金石建設贊助的桌球好手林昀儒獲得T2桌球新加坡站亞軍👍',href:"https://www.facebook.com/kingstonecy1986/posts/2830583966976387"},
          { id: 4, thefiltername: '企業活動', date: '2019.11.19', title: '員工旅遊', content: '金石建設瑞士12天員工旅遊',href:"https://www.facebook.com/kingstonecy1986/posts/2817231264978324"},
          { id: 6, thefiltername: '企業活動', date: '2019.10.24', title: '營業時間', content: '金石接待會館營業時間調整',href:"https://www.facebook.com/kingstonecy1986/posts/2759424147425703"},
          { id: 7, thefiltername: '金石盃賽', date: '2019.09.08', title: '金石盃賽', content: '第三屆金石建設輔大校友盃桌球賽',href:"https://www.facebook.com/kingstonecy1986/posts/2665549210146531"},
          { id: 8, thefiltername: '金石盃賽', date: '2019.09.04', title: '金石盃賽', content: '第二屆金石盃全國桌球錦標賽圓滿落幕',href:"https://www.facebook.com/media/set/?set=a.2657961567571962&type=3"},
          { id: 9, thefiltername: '企業活動', date: '2019.09.02', title: '新聞媒體', content: '2019傑出華商領袖論壇-馬英九總統與企業家面對面活動',href:"https://www.facebook.com/kingstonecy1986/posts/2653894891311963"},
          { id: 10, thefiltername: '企業活動', date: '2019.08.28', title: '新聞媒體', content: '金石建設董事長柯建利榮獲華人公益節-公益大使',href:"https://www.facebook.com/kingstonecy1986/posts/2644676765567109"},
          // { id: 11, thefiltername: '企業活動', date: '2018.5.12', title: '建案作品', content: '金石首品II感恩茶會   邀您一同參加'},
          // { id: 12, thefiltername: '企業活動', date: '2018.4.19', title: '員工旅遊', content: '2018金石建設員工旅遊 澎湖花火節開幕'},
          // { id: 13, thefiltername: '企業活動', date: '2018.4.15', title: '運動比賽', content: '金石建設桌球隊   勇奪社會男子團體冠軍二連霸！'},
          // { id: 14, thefiltername: '企業活動', date: '2018.3.1', title: '運動比賽', content: '2018金石建設第一屆桌球錦標賽正式報名中'},
          // { id: 15, thefiltername: '企業活動', date: '2018.2.24', title: '建案作品', content: '金石首品II  友忠路250號   正式推出'},
          // { id: 16, thefiltername: '企業活動', date: '2017.11.18', title: '員工旅遊', content: '金石建設全體員工北海道公司旅遊（11/19-11/24)'},
          // { id: 17, thefiltername: '企業活動', date: '2017.10.12', title: '建案作品', content: '金石首品最後席次邀您入住   接待中心於嘉義市保安一路270號'},
          // { id: 18, thefiltername: '企業活動', date: '2017.9.11', title: '運動比賽', content: '金石建設舉辦第一屆輔大校友盃桌球賽圓滿成功'},
        ]
    },
    pagesetting(i){
      this.pagenumber = i
      this.limiter = 0
      //console.log(this.pagenumber)
    },

  },
  computed:{
    filternews(){
       return this.newslist.filter((data) => {
         if(data.thefiltername === this.filterchoice){
         return data.thefiltername.includes(this.filterchoice)
                }
         else if(this.filterchoice === ''){
          return data
         }
       })
    },
    pageoffsetnumber(){
      this.limit = 3
      this.setting = Math.ceil(this.filternews.length/ this.limit)
      console.log(this.filternews.length)
      // this.pageoffset = Math.ceil(this.showhow / this.limit)
      return this.setting
    },
  
  }

}
</script>
<style scoped>
.news_component{
  width: 80%;
  height: auto;
  margin:20% auto -2% auto;
  background: #ffffff;
}

.article{
  text-align:center;
  /* width:84%; */
  height: auto;
}

.btn{
  width: 30%;
  height: 51px;
  border: solid 1px #bbbbbb;
  background-color: #ffffff;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.13px;
  color: #7d7d7d;
  cursor: pointer;
}
.btn.active{
  width: 30%;
  height: 51px;
  background-color: #c2b9a6;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.13px;
  color: #ffffff;
  cursor: none;
}

.newslist{
  width:95%;
  height:auto;
  margin: 5% auto -5% auto;
}
#newslistanimation{
  opacity: 0;
  animation: showupnews 0.5s linear forwards;
  -webkit-animation: showupnews 0.5s linear forwards;
  animation-delay: 0.2s;
	-webkit-animation-delay: 0.2s;
}
@keyframes showupnews{
    0%{
      transform: translateY(12px);
    }
    100% {
        opacity: 1;
        }
    }
p{
  width: 100%;
  margin:0 auto;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.63px;
  color: #7d7d7d;
}
a{
  color: #7d7d7d;
  text-decoration: none;
}
#newsdate, #newstitle, #newscontent{
  display: inline-block;
}
#newsdate{
  text-align: center;
  width: 10%;
  margin: 20px 2% 15px 1%;
  color: #7d7d7dac;
}#newstitle{
  text-align: center;
  width: 15%;
  margin: 20px 2% 15px 2%;
  color: #7d7d7dac;
}#newscontent{
  text-align: left;
  width: 60%;
  margin: 20px 0% 15px 2%;
}
#newshr{
  width: 100%;
  height: 0px;
  margin: 0 auto;
  border: solid 0.5px #bbbbbb;
}
#pageoffset{
  text-align: center;
  height: auto;
  /* width: 20%; */
  height:auto;
  margin: auto auto ;
  /* border: solid #bbbbbb; */
}
#pagehrleft{
    display: inline-block;
    width: 38px;
    border: solid 0.3px #97979797;
    margin: 40px 3px 30px 0;
}
#pagehrright{
    display: inline-block;
    width: 38px;
    border: solid 0.3px #97979797;
    margin: 40px 0 30px 3px;
}
.pagep{
    margin: 40px 11px 30px 11px;
    vertical-align:bottom;
    display: inline-block;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.17px;
    text-align: justify;
    color: #8a8a8a;
}
.pagepactive{
  margin: 40px 11px 30px 11px;
  vertical-align:bottom;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.17px;
  text-align: justify;
  color: #d0ad76;
}
.pagep:hover{
  color: #d0ae76a8;
  cursor: pointer;
}


button{
  outline: 0;
  box-shadow: none!important;
}

.seemore-group{
  padding-top:10px;
  padding-bottom:0;
  width: auto;
  height:auto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.17px;
  text-align: justify;
  color: #d0ad76;
  text-decoration: none;
  background: transparent;
  border-bottom: solid 1px #d0ad76;
}
.seemore-group:hover{ cursor: pointer;}

#seemore-news{ 
  margin: 0 2.5% 0 0;
  float:right;
  background: transparent;
}
</style>